var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { runtime } from '../../../../classes/runtime/Runtime';
let MenubarIconEdit = class MenubarIconEdit extends React.PureComponent {
    render() {
        const { app } = this.props;
        if (!app.user || !app.user.userPermissions.hasEditPermissionsForCurrentLocation)
            return null;
        if (!runtime.streamedPackages.Edit)
            return null;
        const initializeEditAndSync = app.edit;
        return (React.createElement("div", { onClick: () => app.appMode.gotoEditMode(app.question), className: "MenubarRightIconButton", style: {} },
            React.createElement("i", { className: `far fa-${app.appMode.isInEditMode ? 'caret-square-right' : 'pencil'}` })));
    }
};
MenubarIconEdit = __decorate([
    observer
], MenubarIconEdit);
export { MenubarIconEdit };
